import { Component } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import { history } from '../../../store';
import UniqueButton from './uniqueButton';

import './styles.css';

class HomePageCarousel extends Component {
  followLink = (link) => {
    if (link && link.match(/^https?:.*/i)) {
      window.open(link, '_blank');
    } else if (link) {
      history.push(link);
    }
  };

  render() {
    const {
      carouselSpeed, carousels, isRedButton
    } = this.props;
    const mobileScreen = window.innerWidth <= 480 && window.innerHeight <= 1097;

    return (
      <Carousel indicators={carousels.length > 1} controls={carousels.length > 1} interval={carouselSpeed * 1000}>
        {carousels.map((carousel, key) => (
          <Carousel.Item key={key}>
            <div className="carousel-image">
              <div className="flex-container">
                <div className='carousel-container'>
                  <img
                    src={mobileScreen && carousel.link.mobile_image ? carousel.link.mobile_image : carousel.link.image}
                    alt={carousel.title}
                    onClick={() => this.followLink(carousel.button_link)}
                  />
                </div>
                {!mobileScreen && (
                <div className="carousel-side">
                  <div>
                    <div className="carousel-title-container">
                      <h2
                        id="carousel-title"
                        className='carousel-title'
                        style={{
                          textAlign: carousel.text_alignment
                        }}
                      >
                        {carousel.title || ''}
                      </h2>
                      <p
                        id="carousel-subtitle"
                        className='carousel-title'
                        style={{
                          textAlign: carousel.text_alignment
                        }}
                      >
                        {carousel.text || ''}
                      </p>
                    </div>
                    <div className='carousel-button-container'>
                      {carousel.button_label && (['Red', 'Yellow', 'White', 'Grey'].includes(carousel.button_color) ? (
                        <Button
                          id="carousel-button"
                          className={isRedButton ? 'red-btn' : `${carousel.button_color.toLowerCase() || 'red'}-ghost-btn`}
                          onClick={() => this.followLink(carousel.button_link)}
                          style={ {
                            position: 'absolute', bottom: 32
                          } }
                        >
                          {carousel.button_label}
                        </Button>
                      ) : (
                        <UniqueButton
                          buttonColor={carousel.button_color}
                          buttonTextColorWhenHover={carousel.button_text_color_when_hover}
                          buttonLink={carousel.button_link}
                          buttonLabel={carousel.button_label}
                        />
                      ))}
                    </div>
                  </div>
                </div>
) }
              </div>
            </div>
          </Carousel.Item>
          ))}
      </Carousel>
    );
  }
}
HomePageCarousel.defaultProps = {
  isRedButton: false
};

export default HomePageCarousel;
